<!-- apps/ers/src/app/modules/ers-leave-management/components/leave-request/leave-request.component.html -->

<div class="leave-request-container" [class.updates-open]="updatesOpen" style="position:relative">
<lm-loading-overlay [show]="isCancelling" message="Processing..."></lm-loading-overlay>
<div class="lm-page-layout">
<div class="lm-main-content">
  <!-- Top Navigation -->
  <div class="top-navigation">

    <!-- ── HR / Admin: view-toggle pill on left ───────────────────────── -->
    <div class="view-toggle">
      <button
        class="toggle-btn"
        [class.active]="selectedView === 'myLeaves'"
        (click)="switchView('myLeaves')">
        {{ 'leave_management.leave_request.my_leaves' | transloco }}
      </button>
      @if (canViewEmployeeRequests) {
      <button
        class="toggle-btn"
        [class.active]="selectedView === 'employeeRequests'"
        (click)="switchView('employeeRequests')">
        {{ 'leave_management.leave_request.employee_leave_request' | transloco }}
      </button>
      }
    </div>

    <!-- ── Employee: main tabs on left (replaces toggle) ─────────────── -->
    @if (selectedView === 'myLeaves') {
    <div class="main-tabs">
      <button
        class="main-tab-btn"
        [class.active]="selectedMainTab === 0"
        (click)="selectMainTab(0)">
        {{ 'leave_management.leave_request.my_leave_balance_amp_requests' | transloco }}
      </button>
      @if (canViewHolidays) {
      <button
        class="main-tab-btn"
        [class.active]="selectedMainTab === 1"
        (click)="selectMainTab(1)">
        {{ 'leave_management.leave_request.holidays' | transloco }}
      </button>
      }
      @if (canViewLeavePolicies) {
      <button
        class="main-tab-btn"
        [class.active]="selectedMainTab === 2"
        (click)="selectMainTab(2)">
        {{ 'leave_management.leave_request.leave_policies' | transloco }}
      </button>
      }
    </div>
    }

  </div>

  <!-- Content Area for My Leaves View -->
  @if (selectedView === 'myLeaves') {
  <div class="my-leaves-content">

    @if (selectedMainTab === 0) {
    <div class="content-area">
    <mat-card class="leave-requests-card">
      <!-- Sub-tabs: Leave Requests | Hourly Permissions | Leave Balance -->
      <div class="sub-tabs">
        <button
          class="sub-tab-btn"
          [class.active]="selectedSubTab === 0"
          (click)="selectedSubTab = 0">
          {{ 'leave_management.leave_request.leave_requests' | transloco }}
        </button>
        <button
          class="sub-tab-btn"
          [class.active]="selectedSubTab === 1"
          (click)="selectedSubTab = 1">
          {{ 'leave_management.leave_request.hourly_permissions' | transloco }}
        </button>
        <button
          class="sub-tab-btn"
          [class.active]="selectedSubTab === 2"
          (click)="selectedSubTab = 2">
          {{ 'leave_management.leave_request.leave_balance' | transloco }}
        </button>
        <div class="sub-tabs-action">
          @if (canViewRequestLeave && selectedSubTab === 0) {
          <button mat-stroked-button color="primary" (click)="onRequestLeave()">
            {{ 'leave_management.leave_request.request_leave' | transloco }}
          </button>
          }
          @if (selectedSubTab === 1) {
          <button mat-stroked-button color="primary" (click)="onRequestHourlyPermission()">
            {{ 'leave_management.leave_request.hourly_permission' | transloco }}
          </button>
          }
        </div>
      </div>

      <!-- Leave Requests Grid -->
      @if (selectedSubTab === 0) {
      <div class="grid-wrapper">
        <ers-grid
          [rowData]="displayData"
          [columnDefs]="columnDefs"
          [gridOptions]="gridOptions"
          [showToolPanels]="false"
          (cellClicked)="onGridCellClick($event)">
        </ers-grid>
      </div>
      }

      <!-- Hourly Permissions Grid -->
      @if (selectedSubTab === 1) {
      <div class="grid-wrapper">
        <ers-grid
          [rowData]="hourlyDisplayData"
          [columnDefs]="hourlyColumnDefs"
          [gridOptions]="gridOptions"
          [showToolPanels]="false"
          (cellClicked)="onHourlyCellClick($event)">
        </ers-grid>
      </div>
      }

      <!-- Leave Balance Content -->
      @if (selectedSubTab === 2) {
      <div class="balance-content">
        <div class="balance-header">
          <div class="balance-actions">
            @if (canViewGiftOfTime) {
            <button mat-stroked-button class="gift-btn" (click)="onGiftOfTime()">
              <mat-icon>{{ 'leave_management.leave_request.card_giftcard' | transloco }}</mat-icon>
              {{ 'leave_management.leave_request.gift_of_time' | transloco }}
            </button>
            }
            @if (canViewAvailGiftOfTime) {
            <button mat-raised-button class="avail-gift-btn"
                    (click)="onAvailGiftOfTime()">
              <mat-icon>{{ 'leave_management.leave_request.lock' | transloco }}</mat-icon>
              Avail Gift of Time ({{ giftedLeaveBalance.balanceRemaining }})
            </button>
            }
          </div>
        </div>

        <div class="balance-grid-wrapper">
          <ers-grid
            [rowData]="balanceRowData"
            [columnDefs]="balanceColumnDefs"
            [gridOptions]="balanceGridOptions"
            [showToolPanels]="false"
            (cellClicked)="onBalanceCellClick($event)">
          </ers-grid>
        </div>

        <div class="balance-footer">
          <small>{{ 'leave_management.leave_request.note_employee_avails_more_casual_leaves_than_allocated' | transloco }}</small>
        </div>
      </div>
      }
    </mat-card>
  </div>
  }

  <!-- Holidays Tab Content -->
  @if (selectedMainTab === 1) {
  <div class="content-area">
    <ers-holidays-tab></ers-holidays-tab>
  </div>
  }

  <!-- Leave Policies Tab Content -->
  @if (selectedMainTab === 2) {
  <div class="content-area">
    <ers-leave-policies></ers-leave-policies>
  </div>
  }
  </div>
  }

  <!-- Content Area for Employee Requests View (HR / Admin only) -->
  @if (selectedView === 'employeeRequests' && canViewEmployeeRequests) {
  <div class="employee-requests-content">
    <div class="content-area">
      <ers-employee-leave-request
        [isManager]="isManager"
        [canViewAllRequests]="hasConfigurationsAccess"
        [canViewLeaveBalanceTab]="canViewEmployeeBalanceTab"
        [employeeSection]="selectedEmployeeTab === 1 ? 'balance' : 'requests'"
        (employeeSectionChange)="onEmployeeSectionChange($event)">
      </ers-employee-leave-request>
    </div>
  </div>
  }
</div><!-- /lm-main-content -->

<!-- ── SVG toggle tab ──────────────────────────────────────────────────── -->
<button class="lm-updates-toggle" (click)="toggleNotificationPanel()" [class.open]="showNotificationPanel" [title]="'leave_management.leave_request.title.updates_from_manager' | transloco">
  <svg width="17" height="170" viewBox="0 0 17 170" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.63123 60.5C14.6312 46.9 16.6312 14.5 16.6312 0V127C16.6312 115.5 9.63135 105 4.63135 98C-0.368652 91 -3.36877 77.5 6.63123 60.5Z" fill="#333333"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.2979 84.9583L12.6013 85.6663L7.49061 80.473C7.36761 80.3461 7.29883 80.1764 7.29883 79.9997C7.29883 79.823 7.36761 79.6532 7.49061 79.5263L12.6013 74.333L13.2979 75.0417L8.41928 79.9997L13.2979 84.9583Z" fill="white"/>
  </svg>
</button>

<!-- ── Updates from Manager panel ─────────────────────────────────────── -->
<lib-manager-notification-panel
  [notifications]="managerUpdates"
  [loading]="notificationLoading"
  [isOpen]="showNotificationPanel"
  (closed)="toggleNotificationPanel()">
</lib-manager-notification-panel>

</div><!-- /lm-page-layout -->
</div>
